import Full from '@rebuild/materials/shared/appointment/FullIndex.vue';
import Form from '@rebuild/materials/shared/appointment/Form.vue';
import Result from '@rebuild/materials/shared/appointment/Result.vue';

export const componentMap = {
	full: Full,
	form: Form,
	result: Result
};
